import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../content/siteContent";
import { Reveal, Overline } from "./Reveal";
import { IconCheck } from "./Icons";

const WhyChooseUs = () => {
    const { t } = useLanguage();
    return (
        <section id="why" className="relative scroll-mt-24 overflow-hidden py-12 md:py-20" aria-labelledby="why-title" data-testid="why-section">
            <div
                aria-hidden="true"
                className="animate-drift-slow pointer-events-none absolute -bottom-40 start-[-12%] h-[30rem] w-[30rem] rounded-full opacity-60 blur-3xl"
                style={{ background: "radial-gradient(circle, rgba(0,77,77,0.10) 0%, rgba(178,143,55,0.14) 50%, transparent 70%)" }}
            />
            <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-8">
                <div>
                    <Reveal>
                        <Overline>{t.why.overline}</Overline>
                        <h2 id="why-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
                            {t.why.title}
                        </h2>
                    </Reveal>
                    <ul className="mt-10 space-y-7">
                        {t.why.items.map((item, i) => (
                            <Reveal key={item.title} delay={Math.min(i * 0.07, 0.3)}>
                                <li className="flex gap-4" data-testid={`why-item-${i + 1}`}>
                                    <span className="mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-pine text-gold-500">
                                        <IconCheck className="h-4 w-4" />
                                    </span>
                                    <div>
                                        <h3 className="text-lg font-semibold text-ink">{item.title}</h3>
                                        <p className="mt-1 text-sm leading-relaxed text-mist md:text-base">{item.desc}</p>
                                    </div>
                                </li>
                            </Reveal>
                        ))}
                    </ul>
                </div>
                <Reveal className="relative">
                    <div aria-hidden="true" className="absolute -inset-3 rounded-[2.2rem] rounded-se-none border border-gold-500/40 sm:-inset-4" />
                    <div className="relative overflow-hidden rounded-[2rem] rounded-se-none shadow-[0_30px_60px_-30px_rgba(0,77,77,0.4)]">
                        <img
                            src={IMAGES.clinic}
                            alt={t.why.imageAlt}
                            width="940"
                            height="1050"
                            loading="lazy"
                            className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-[1.03] sm:aspect-[5/5]"
                        />
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default WhyChooseUs;
